import React from 'react';
import V2Layout from '../components/V2Layout';
import V2AccountNav from '../components/V2AccountNav';
import useV2Auth from '../hooks/useV2Auth';
import {
  V2ProfileEmailPanel,
  V2ProfilePasswordPanel,
  V2ProfileSupportPanel,
} from '../components/V2ProfilePanels';

const V2Profile: React.FC = () => {
  const { user } = useV2Auth();
  const [compact, setCompact] = React.useState(false);

  if (!user) {
    return null;
  }

  return (
    <V2Layout
      activeNav="profile"
      compact={compact}
      onToggleCompact={() => setCompact((value) => !value)}
      userEmail={user.email}
      breadcrumbs={
        <p className="breadcrumbs">
          Аккаунт <span>/</span> <strong>Профиль</strong>
        </p>
      }
      footerNote="Мой аккаунт"
    >
      <div className="v2-account-page">
        <section className="player-heading player-heading--page">
          <div>
            <div className="player-title-line">
              <h1>Мой аккаунт</h1>
            </div>
            <p className="profile-description">Email, пароль и обратная связь</p>
          </div>
        </section>

        <V2AccountNav active="profile" />

        <section className="settings-section profile-stack" aria-label="Мой аккаунт">
          <div className="settings-stack">
            <V2ProfileEmailPanel user={user} />
            <V2ProfilePasswordPanel />
            <V2ProfileSupportPanel />
          </div>
        </section>
      </div>
    </V2Layout>
  );
};

export default V2Profile;
